import { scaleLinear, scaleLog, scalePow, scaleSqrt, scaleTime, scaleUtc, scaleQuantile, scaleQuantize, scaleThreshold, scaleOrdinal, scalePoint, scaleBand, scaleSymlog } from 'd3-scale';
import { ScaleType } from '../../types';
export default function createScaleFromScaleType(type) {
  switch (type) {
    case ScaleType.LINEAR:
      return scaleLinear();

    case ScaleType.LOG:
      return scaleLog();

    case ScaleType.POW:
      return scalePow();

    case ScaleType.SQRT:
      return scaleSqrt();

    case ScaleType.TIME:
      return scaleTime();

    case ScaleType.UTC:
      return scaleUtc();

    case ScaleType.QUANTILE:
      return scaleQuantile();

    case ScaleType.QUANTIZE:
      return scaleQuantize();

    case ScaleType.THRESHOLD:
      return scaleThreshold();

    case ScaleType.ORDINAL:
      return scaleOrdinal();

    case ScaleType.POINT:
      return scalePoint();

    case ScaleType.BAND:
      return scaleBand();

    case ScaleType.SYMLOG:
      return scaleSymlog();

    case ScaleType.BIN_ORDINAL:
      // TODO: Pending scale.bins implementation
      throw new Error("\"type = " + type + "\" is not supported yet.");

    default:
      return scaleLinear();
  }
}